import styled from "styled-components";
import {
  ButtonContained,
  ButtonOutlined,
  ButtonText,
  FontStyles,
} from "../../../components";

const Container = styled.div(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    paddingBlock: theme.spacing(5),
    borderRadius: "55px",
    flex: 1,
    width: "100%",
    maxWidth: 'clamp(300px, 80vw, 600px)',
    [theme.breakpoints.down("sm")]: {
      maxWidth: "88vw",
      paddingBlock: theme.spacing(2.5),
      borderRadius: "35px",
    },
  };
});
const ContainerExtra = styled.div(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    paddingBlock: theme.spacing(8),
    borderRadius: "55px",
    height: "100%",
    width: "100%",
    maxWidth: 'clamp(300px, 80vw, 600px)',
    [theme.breakpoints.down("sm")]: {
      maxWidth: "88vw",
      paddingBlock: theme.spacing(2.5),
      borderRadius: "35px",
    },
  };
});

const InputImage = styled.div(({ theme }) => {
  return {
    ...FontStyles.medium14,
    padding: theme.spacing(1.57, 2.5),

    marginTop: theme.spacing(1.5),
    textOverflow: "ellipsis",

    backgroundColor: theme.palette.primary.contrastText,
    borderBottom: "0px",
    borderRadius: theme.spacing(0.6),
    display: "flex",
    justifyContent: "space-between",
  };
});
const InputImageModal = styled.div(({ theme }) => {
  return {
    ...FontStyles.medium14,
    padding: theme.spacing(1, 2.5),

    marginTop: theme.spacing(1.5),

    backgroundColor: "transparent",

    border: "2px solid " + theme.palette.primary.contrastText,

    borderRadius: theme.spacing(0.6),
    display: "flex",
    justifyContent: "center",
    width: "100%",

    cursor: "pointer",
  };
});

const InputImageClick = styled.label(({ theme }) => {
  return {
    width: "100%",
    height: "100%",
    flex: 1,
    cursor: "pointer",
    alignItems: "center",
    overflow: "hidden",
    display: "block",
  };
});
const InputView = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.medium12,
      textDecoration: "underline",
      color: "#24272A",
      padding: 0,
      paddingInline: 6,
      margin: 0,
    },
  };
});

const SendForm = styled(ButtonContained)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.semibold16,

      padding: "16px",
      paddingInline: "20px",
      margin: 0,
    },
  };
});

const buttonlink = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.semibold16,
      color: "#4D585A",
      padding: "16px",
      paddingInline: "20px",
      margin: 0,
    },
  };
})


const Back = styled(ButtonOutlined)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.semibold16,

      padding: "8px",
      paddingInline: "12px",
      margin: 0,
    },
  };
});
const Clear = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.semibold16,
      color: "#4D585A",
      padding: "16px",
      paddingInline: "20px",
      margin: 0,
    },
  };
});

const BackPhoto = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.semibold16,
      color: "#fff",
      padding: "16px",
      paddingInline: "20px",
      margin: 0,
    },
  };
});

const SendPhoto = styled(ButtonContained)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.medium12,
      backgroundColor: "#fff",
      color: "#24272A",
      padding: "16px",
      paddingInline: "20px",
      margin: 0,
      "&:hover": {
        backgroundColor: "#FFFFFFE6",
      },
    },
  };
});

const HeaderSteps = styled.div(({ theme }) => {
  return {
    width: "100%", paddingInline: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      paddingInline: theme.spacing(2.5),
    },
  };
})


const ContainerEmprendimento = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    gap: "12px",
    marginTop: "12px",
    borderRadius: "16px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      padding: "10px 14px",
      gap: "10px",
    },
  };
});

const LogoBox = styled.div(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50px",
    height: "50px",
    minWidth: "48px",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
    "& img": {
      width: "100%",
      height: "100%",
      padding: "0px",
      objectFit: "contain",
      backgroundColor: "transparent",
    },
  };
});

const EmailBox = styled.div`
  width: 100%;
  max-width: 320px;
  border-radius: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
`;

const EmailText = styled.span`
  display: inline-block;
  white-space: nowrap;
  min-width: 100%;
`;
const Styles = {
  Container,
  InputImage,
  InputView,
  InputImageClick,
  Clear,
  SendForm,
  Back,
  ContainerExtra,
  BackPhoto,
  SendPhoto,
  buttonlink,
  InputImageModal,
  HeaderSteps,
  ContainerEmprendimento,
  LogoBox,
  EmailBox,
  EmailText,
};

export default Styles;
